import {Component} from '@angular/core';

@Component({
    selector: 'tfl-input-warning-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
                <path stroke="#FFC212" d="M.867 22.227L12 2.997l11.133 19.23H.867z"/>
                <path fill="#FFC212" d="M11 17H13V19H11zM11 11H13V15H11z"/>
            </g>
        </svg>
    `
})
export class WarningIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/warning.icon.ts